/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  return $('.js-promotion').each(function() {
    if (($(this).find('.js-content-container p:last-child').clone().children().remove().end().text().length < 1) && ($(this).find("[data-target='extended-content']").length === 0)) {
      return $(this).find('.js-content p:last-child a:last-child').addClass("button button--".concat($(this).data("context"), " mt3"));
    }
  });
});
